export var IssueRole;
(function (IssueRole) {
    IssueRole["OWNER"] = "owner";
    IssueRole["ASSIGNEE"] = "assignee";
    IssueRole["VIEWER"] = "viewer";
})(IssueRole || (IssueRole = {}));
